import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class NakladoveStrediskoProvider extends BaseApi {
	getEntity(provozovnaId: string | number, strednaklOzn: string | number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/${provozovnaId}/${strednaklOzn}`);
	}

	async IsCostCenterAlreadyUsed(id: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsCostCenterAlreadyUsed?id=${id}`);
	}
}

export const apiProvider = new NakladoveStrediskoProvider(DMS_MODULE, NAME);
